import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import home from '@/components/home.vue'
import login from '@/components/login.vue'
import main from '@/components/index/index'
import analysis from '@/components/analysis/index'
import inquiry from '@/components/inquiry/index'
import push from '@/components/push/index'
import airanking from '@/components/ranking/airanking'
import nranking from '@/components/ranking/nranking'
import paid from '@/components/ranking/paid'
import thesaurus from '@/components/thesaurus/index'
import account from '@/components/system/index'
import recharge from '@/components/system/recharge'
import bwlist from '@/components/system/bwlist'
import message from '@/components/system/message'
import service from '@/components/system/service'
import security from '@/components/system/security/index'
import base from '@/components/system/base/index'
import detail from '@/components/system/message-detail'
import ipblack from '@/components/system/ipblack'
import time from '@/components/system/time'

import flowsource from '@/components/flow/flowsource'
import flowtype from '@/components/flow/flowtype'
import menu from '@/components/menu/index'
import role from '@/components/role/index'
import user from '@/components/user/index'
import staff from '@/components/user/staff'
import statistics from '@/components/system/statistics'
import guest from '@/components/system/guest'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {name:'login',path: '/', component: login},
    {
      name:'home',path: '/home', component: home, 
      children: [
        {name: 'main',path: 'main', component: main},
        {name: 'analysis',path: 'analysis',component: analysis},
        {name: 'inquiry',path: 'inquiry',component: inquiry},
        {name: 'push',path: 'push',component: push},
        {name: 'airanking',path: 'airanking',component: airanking},
        {name: 'nranking',path: 'nranking',component: nranking},
        {name: 'paid',path: 'paid',component: paid},
        {name: 'thesaurus',path: 'thesaurus',component: thesaurus},
        {name: 'account',path: 'account',component: account, 
          children: [
            {name:'base',path: 'base', component: base, },
            {name:'security',path: 'security', component: security}, 
          ],
          redirect: {path: 'account/base' },
        },
        {name: 'guest',path: 'guest',component: guest},
        {name: 'recharge',path: 'recharge',component: recharge},
        {name: 'bwlist',path: 'bwlist',component: bwlist},
        {name: 'message',path: 'message',component: message},
        {name: 'service',path: 'service',component: service},
        {name: 'detail',path: 'detail',component: detail},
        {name: 'menu',path: 'menu',component: menu},
        {name: 'role',path: 'role',component: role},
        {name: 'flowsource',path: 'flowsource',component: flowsource},
        {name: 'flowtype',path: 'flowtype',component: flowtype},
        {name: 'user',path: 'user',component: user},
        {name: 'staff',path: 'staff',component: staff},
        {name: 'statistics',path: 'statistics',component: statistics},
        {name: 'ipblack',path: 'ipblack',component: ipblack},
        {name: 'time',path: 'time',component: time},
      ],
      redirect: {path: 'main' },
    }
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js